import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';
import { Roles } from 'infrastructure/enums';
import useUser from 'utils/useUser';

import s from './styles.module.scss';

export type ProviderDashboardTab = 'summary' | 'providers';

interface IProviderDashboardHeaderProps {
  activeTab: ProviderDashboardTab;
  onTabChange: (tab: ProviderDashboardTab) => void;
}

export const ProviderDashboardHeader: React.FC<
  IProviderDashboardHeaderProps
> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();
  const { hasAnyRole } = useUser();
  const isAccountManager = hasAnyRole([Roles.AccountManager]);

  return (
    <div className={s.pageHeader}>
      <div className={s.titleWithInfo}>
        <h1 className={s.title}>{t('links.providerDashboard')}</h1>
      </div>
      <div className={s.actionsRow}>
        {/* <BaseDropdownButton
          dataCy="provider-dashboard-download-report"
          label={t('labels.downloadReport')}
          rightIcon={<ChevronBottom />}
          type="secondary"
          height="30px"
          className={s.downloadButton}
          items={[
            { key: 'pdf', label: 'PDF', onClick: () => {} },
            { key: 'excel', label: 'Excel', onClick: () => {} },
          ]}
        /> */}
        <div className={s.segmentGroup}>
          <BaseButton
            dataCy="provider-dashboard-summary"
            type={activeTab === 'summary' ? 'primary' : 'secondary'}
            label={t('labels.summary')}
            onClick={() => onTabChange('summary')}
            className={`${s.segmentButton} ${s.segmentButtonFirst} ${
              activeTab === 'summary'
                ? s.segmentButtonActive
                : s.segmentButtonInactive
            }`}
          />
          {isAccountManager && (
            <BaseButton
              dataCy="provider-dashboard-providers"
              type={activeTab === 'providers' ? 'primary' : 'secondary'}
              label={t('labels.providersTab')}
              onClick={() => onTabChange('providers')}
              className={`${s.segmentButton} ${s.segmentButtonLast} ${
                activeTab === 'providers'
                  ? s.segmentButtonActive
                  : s.segmentButtonInactive
              }`}
            />
          )}
        </div>
      </div>
    </div>
  );
};
